import { render } from "./App.vue?vue&type=template&id=9e4a7b98"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9e4a7b98&lang=stylus"

import exportComponent from "/Users/o.borysenko/Documents/Lokal Google Drive/PARTNERKA/Betting_landing_cybersport/betting_cybersport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__